<template>
  <div id='box'>
    <div class='body'>
      <div v-show="!isShowRoom" class="course-wrap">
         <nav-tab-view :list="navTabData" @tabClick="tabClick">

         </nav-tab-view>
         <course-list class="course-list" :classes="classes" @itemClick="courseListClick"></course-list>
      </div>
      <div v-show="isShowRoom" class="rooms-warp">
         <div class="room-nav-back">
            <img src="@/assets/live/back_icon.png" @click="backClick" />
            <span class="course-title">
              {{courseTitle}}
            </span>
         </div>
         <live-rooms class="liverooms" :liveRooms="liveRooms"></live-rooms>
      </div>

    </div>

  </div>
</template>

<script>
import courseList from '@/components/live/CourseList'
import LiveRooms from '@/components/live/Liverooms'
import NavTabView from '@/components/live/NavTabView'
export default {
  name: 'CourseList',
  components: {
    courseList,
    LiveRooms,
    NavTabView
  },
  data () {
    return {
      classes: [],
      liveRooms: [],
      isShowRoom: false,
      courseTitle: '',
      timeOut: 0,
      navTabData: [
        {
          name: '全部课程',
          val: 0
        },
        {
          name: '已过期课程',
          val: 1
        }
      ]
    }
  },
  created () {
    this.getUserClasses()
  },
  methods: {
    tabClick: function (item) {
      this.timeOut = item.val
      this.getUserClasses()
    },
    backClick: function () {
      this.isShowRoom = false
      this.liveRooms = []
    },
    courseListClick: function (item) {
      this.courseTitle = item.class_name
      this.isShowRoom = true
      // http://localhost:8080/classSvr/api/v1/class/rooms?group_id=1&class=3&user_type=0
      let data = {
        group_id: item.group_id,
        class: item.class_id,
        user_type: this.$store.getters.getUserType
      }
      let roomArray = []
      this.liveRooms = []
      this.$api.liveServer.getUserClassRooms(data).then(res => {
        if (res.code === 0) {
          res.data.forEach(item => {
            item.begin_time = item.begin
            let newItem = {
              begin_time: item.begin,
              course_id: item.class_id,
              end_time: item.end,
              group_id: item.group_id,
              live_id: item.room_id,
              live_type: item.room_type,
              title: item.room_name,
              status: item.status,
              teachers: JSON.parse(item.teachers)
            }
            roomArray.push(newItem)
          })

          // 排序，正序
          this.liveRooms = roomArray.sort(function (a, b) {
              return (a.begin_time <= b.begin_time ? -1 : 1);
          })
        }
      })
    },
    getUserClasses () {
      this.classes = []
      // http://localhost:8080/classSvr/api/v1/user/class?time_out=0&user_type=0
      var data = {time_out: this.timeOut, user_type: this.$store.getters.getUserType} // time_out: 1.未过期，0.已过期。user_type: 0.学生，1.老师
      this.$api.liveServer.queryUserClasses(data).then(res => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        if (res.data.classes) {
          res.data.classes.forEach(item => {
            item.isActive = false
          })
          this.classes = res.data.classes
          console.log(this.classes)

          if (this.classes.length > 0) {
            this.choicedClassItem = this.classes[0]
          }
        }
      }).catch(err => {
        return this.$message.error(err.msg)
      })
    }
  }
}
</script>

<style scoped>

  .rooms-warp{
    padding: 20px;
  }
  .room-nav-back{
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .room-nav-back img{
    width: 20px;
    cursor: pointer;
  }

  .room-nav-back span{
    color: #4A4A4A;
    font-size: 18px;
    margin-left: 20px;
  }

  .course-wrap{
    display: flex;
    flex-direction: column;
    padding: 20px;
  }

  .course-list{
    margin-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/page/live/Courses.vue